import React from "react";
import styled from "@emotion/styled";
import Icon from "~/core/scripts/components/Icon";
import { useTheme } from "emotion-theming";

import LayerWrapper from "./LayerWrapper";
import matrix from "../matrix";

const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  height: 100%;
  width: 100%;
`;

const itemSize = (1 / matrix[0].length) * 100;

const ItemWrapper = styled.div`
  height: ${itemSize}%;
  width: ${itemSize}%;
  background: #eee;
  border: 1px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Item = ({ isBiden, small, tiny }) => {
  const theme = useTheme();
  return (
    <ItemWrapper>
      <Icon
        style={{
          fontSize: tiny ? 20 : small ? 40 : 50,
          color: isBiden ? theme.colors.democratic : theme.colors.republican,
        }}
        type={isBiden ? "house--dem" : "house--rep"}
      />
    </ItemWrapper>
  );
};

const ElectionGrid = ({ small = false, tiny = false }) => {
  return (
    <LayerWrapper>
      <ItemsWrapper>
        {matrix.map((row) =>
          row.map((col, i) => (
            <Item key={`item-${i}`} isBiden={col} small={small} tiny={tiny} />
          ))
        )}
      </ItemsWrapper>
    </LayerWrapper>
  );
};

export default ElectionGrid;
